
export const FAISHION_REQUEST="FAISHION_REQUEST"
export const FAISHION_SUCCESS="FAISHION_SUCCESS"
export const FAISHION_FAILURE="FAISHION_FAILURE"
